const statusTypes = Object.freeze({
  notApplicable: 'NA',
  onHand: 'onHand',
  confirmedAvailable: 'confirmedAvailable',
  scheduled: 'scheduled',
  current: 'current',
  active: 'active',
  operational: 'operational',
  working: 'working',
  static: 'static',
  total: 'total',
})

export default statusTypes
